import { __decorate, __param } from 'tslib';
import { InjectionToken, Inject, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { sizeBigger, TuiHostedDropdownComponent, TuiTextfieldSizeDirective, TUI_TEXTFIELD_SIZE, TuiSvgModule } from '@taiga-ui/core';
import { PolymorpheusComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { CommonModule } from '@angular/common';

// TODO: remove in ivy compilation
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc2 from '@taiga-ui/core';
import * as ɵngcc3 from '@angular/common';

function TuiArrowComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 1);
} if (rf & 2) {
    const icon_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("src", icon_r1);
} }
const TUI_ARROW_ICON_SMALL = 'tuiIconChevronDown';
const TUI_ARROW_ICON_LARGE = 'tuiIconChevronDownLarge';
/** Default values for arrow options */
const TUI_ARROW_DEFAULT_OPTIONS = {
    iconSmall: TUI_ARROW_ICON_SMALL,
    iconLarge: TUI_ARROW_ICON_LARGE,
};
const TUI_ARROW_OPTIONS = new InjectionToken('Default parameters for arrow component', {
    factory: () => TUI_ARROW_DEFAULT_OPTIONS,
});
const tuiArrowOptionsProvider = (options) => ({
    provide: TUI_ARROW_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_ARROW_DEFAULT_OPTIONS), options),
});
const TUI_ARROW_MODE = new InjectionToken('Type of icon in dropdowns for interactive or disable mode', {
    factory: () => ({
        interactive: TUI_ARROW,
        disabled: TUI_ARROW,
    }),
});
const tuiArrowModeProvider = (options) => ({
    provide: TUI_ARROW_MODE,
    useValue: Object.assign({ interactive: TUI_ARROW, disabled: TUI_ARROW }, options),
});

let TuiArrowComponent = class TuiArrowComponent {
    constructor(dropdown, textfieldSize, options) {
        this.dropdown = dropdown;
        this.textfieldSize = textfieldSize;
        this.options = options;
    }
    get arrowIcon() {
        return sizeBigger(this.textfieldSize.size)
            ? this.options.iconLarge
            : this.options.iconSmall;
    }
};
TuiArrowComponent.ɵfac = function TuiArrowComponent_Factory(t) { return new (t || TuiArrowComponent)(ɵngcc0.ɵɵdirectiveInject(TuiHostedDropdownComponent), ɵngcc0.ɵɵdirectiveInject(TUI_TEXTFIELD_SIZE), ɵngcc0.ɵɵdirectiveInject(TUI_ARROW_OPTIONS)); };
TuiArrowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiArrowComponent, selectors: [["tui-arrow"]], decls: 3, vars: 5, consts: [["polymorpheus-outlet", "", 1, "t-icon", 3, "content"], [3, "src"]], template: function TuiArrowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, TuiArrowComponent_ng_template_2_Template, 1, 1, "ng-template");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("t-icon_rotated", ɵngcc0.ɵɵpipeBind1(1, 3, ctx.dropdown.openChange));
        ɵngcc0.ɵɵproperty("content", ctx.arrowIcon);
    } }, directives: [ɵngcc1.PolymorpheusOutletComponent, ɵngcc2.TuiSvgComponent], pipes: [ɵngcc3.AsyncPipe], styles: [".t-icon[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:block;cursor:pointer;pointer-events:none}.t-icon_rotated[_ngcontent-%COMP%]{transform:rotate(180deg)}"], changeDetection: 0 });
TuiArrowComponent.ctorParameters = () => [
    { type: TuiHostedDropdownComponent, decorators: [{ type: Inject, args: [TuiHostedDropdownComponent,] }] },
    { type: TuiTextfieldSizeDirective, decorators: [{ type: Inject, args: [TUI_TEXTFIELD_SIZE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ARROW_OPTIONS,] }] }
];
TuiArrowComponent = __decorate([ __param(0, Inject(TuiHostedDropdownComponent)),
    __param(1, Inject(TUI_TEXTFIELD_SIZE)),
    __param(2, Inject(TUI_ARROW_OPTIONS))
], TuiArrowComponent);
const TUI_ARROW = new PolymorpheusComponent(TuiArrowComponent);

let TuiArrowModule = class TuiArrowModule {
};
TuiArrowModule.ɵfac = function TuiArrowModule_Factory(t) { return new (t || TuiArrowModule)(); };
TuiArrowModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiArrowModule });
TuiArrowModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiSvgModule, PolymorpheusModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiArrowComponent, [{
        type: Component,
        args: [{
                selector: 'tui-arrow',
                template: "<span\n    polymorpheus-outlet\n    class=\"t-icon\"\n    [class.t-icon_rotated]=\"dropdown.openChange | async\"\n    [content]=\"arrowIcon\"\n>\n    <ng-template let-icon>\n        <tui-svg [src]=\"icon\"></tui-svg>\n    </ng-template>\n</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".t-icon{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:block;cursor:pointer;pointer-events:none}.t-icon_rotated{transform:rotate(180deg)}"]
            }]
    }], function () { return [{ type: ɵngcc2.TuiHostedDropdownComponent, decorators: [{
                type: Inject,
                args: [TuiHostedDropdownComponent]
            }] }, { type: ɵngcc2.TuiTextfieldSizeDirective, decorators: [{
                type: Inject,
                args: [TUI_TEXTFIELD_SIZE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ARROW_OPTIONS]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiArrowModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiSvgModule, PolymorpheusModule],
                declarations: [TuiArrowComponent],
                exports: [TuiArrowComponent],
                entryComponents: [TuiArrowComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiArrowModule, { declarations: function () { return [TuiArrowComponent]; }, imports: function () { return [CommonModule, TuiSvgModule, PolymorpheusModule]; }, exports: function () { return [TuiArrowComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_ARROW, TUI_ARROW_DEFAULT_OPTIONS, TUI_ARROW_ICON_LARGE, TUI_ARROW_ICON_SMALL, TUI_ARROW_MODE, TUI_ARROW_OPTIONS, TuiArrowComponent, TuiArrowModule, tuiArrowModeProvider, tuiArrowOptionsProvider };

